import { render, staticRenderFns } from "./DepositForm.vue?vue&type=template&id=85185f6c&"
import script from "./DepositForm.vue?vue&type=script&lang=js&"
export * from "./DepositForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports